import { Provider } from '@angular/core';
import { OLR_VERSION } from '@common';
import { ContentModuleConfig } from '../models/content-module-config.interface';
import { provideContentDictionaryMapping } from '../utils/content-dictionary.utils';

export function provideContentDefaults(config?: ContentModuleConfig): Provider {
  return [
    {
      provide: OLR_VERSION,
      useValue: config?.olrVersion,
    },
    provideContentDictionaryMapping(config?.contentDictionaryMapping),
  ];
}
